import { render, staticRenderFns } from "./sheetmetalprofile.vue?vue&type=template&id=2cc6655f&"
import script from "./../../ts/partcreation/sheetmetalprofile.ts?vue&type=script&lang=js&"
export * from "./../../ts/partcreation/sheetmetalprofile.ts?vue&type=script&lang=js&"
import style0 from "./../../assets/css/partcreation/sheetmetalprofile.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports